import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import SmsCampaignsList from './SmsCampaignsList'

export default function SmsCampaigns() {
    return (
        <React.Fragment>
            <Switch>
                <Route exact path="/sms_campaigns" component={SmsCampaignsList} />

                <Redirect to="/404" />
            </Switch>
        </React.Fragment>
    )
}